import * as Actions from '../../actions';

const initialState = {
    data: [],
    selected: {
        data: {},
        isLoading: false,
        error:false,
    },
    isLoading: false,
    error: false
};

const getImagesReducer = (state = initialState, action) => {
    switch (action.type) {
        case Actions.GET_IMAGES: case Actions.GET_COMMON_IMAGES : {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.GET_IMAGES_SUCCESS:  case Actions.GET_COMMON_IMAGES_SUCCESS: {
            return {
                ...state,
                data: action.payload,
                isLoading: false,
                error: false
            };
        }
        case Actions.GET_IMAGES_ERROR: case Actions.GET_COMMON_IMAGES_ERROR : {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }
            
        case Actions.GET_IMAGE: {
            return {
                ...state,
                selected: {
                    ...state.selected,
                    isLoading: true,
                    error: false
                }
             
            };
        }
        case Actions.GET_IMAGE_SUCCESS: {
            return {
                ...state,
                selected: {
                    data: action.payload,
                    isLoading: false,
                    error:false
                }
            };
        }
        case Actions.GET_IMAGE_ERROR: {
            return {
                ...state,
                selected:{
                    data: {},
                    isLoading: false,
                    error:action.payload
                }
            };
        }
                        
        case Actions.ADD_IMAGE: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.ADD_IMAGE_SUCCESS: {
            return {
                ...state,
                data: [action.payload, ...state.data],
                isLoading: false,
                error: false
            };
        }
        case Actions.ADD_IMAGE_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }
        case Actions.UPDATE_IMAGE: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.UPDATE_IMAGE_SUCCESS: {

            const index=state.data.findIndex(p => p._id===action.payload._id)
            state.data[index]= action.payload
            return {
                ...state,
                isLoading: false,
                error: false
            };
        }
        case Actions.UPDATE_IMAGE_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }
            
        case Actions.DELETE_IMAGE: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.DELETE_IMAGE_SUCCESS: {
            return {
                ...state,
                data: state.data.filter(p => p._id !== action.payload),
                isLoading: false,
                error: false
            };
        }
        case Actions.DELETE_IMAGE_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }
            
        case Actions.LOGOUT: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.LOGOUT_SUCCESS: {
            return {
                data: [],
                selected :{
                    data: null,
                    isLoading: false,
                    error: false,
                },
                isLoading: false,
                error: false
            }
        }
        case Actions.LOGOUT_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            }
        }
            
            
        default: {
            return state;
        }
    }
};

export default getImagesReducer 